import React, { Component } from 'react'
import "./LTIQuizMapping.css"
import { Button, Card, SelectField, SelectionControlGroup } from 'react-md'
import ApiRequestService from '../component/ApiRequestService'
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import MultiSelectReact from 'react-multi-select-ext'
import { AppProperties } from '../common/function';
import { Link } from 'react-router';

const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000'
};


export default class LTIQuizMapping extends Component {

    appProperties = AppProperties();
    constructor(props) {
        super(props);
        this.state = {
            courses: null,
            courseMenuItems: [],
            showEmptyCourseMsg: false,

            sections: null,
            sectionMenuItems: [],
            showEmptySectionMsg: false,

            assignments: null,
            assignmentMenuItems: [],
            assignmentMultiSelectItems: [],
            showEmptyAssignmentMsg: false,

            selectedCourse: null,
            selectedSection: null,
            selectedAssignmentIDArr: [],
            selectedAssignments: [],

            selectedRadioValue: '',

            isMapped: false,
            loading: false,

            carmenAssignmentTitle: '',
            ltiQuizID: '',
            ltiSectionID: '',
            ltiUserID: '',
            carmenAssignmentID: '',
            carmenCourseID: '',
            carmenCourseName: '',

            carmenAssignmentURL: '',
            constructTakeQuizURLData: '',

            data: null,
            editMode: false,
        };

        this.handleCourseSelect = this.handleCourseSelect.bind(this);
        this.handleSectionSelect = this.handleSectionSelect.bind(this);
        this.handleRadioValueChange = this.handleRadioValueChange.bind(this);
        this.handleAssignmentSelect = this.handleAssignmentSelect.bind(this);
        this.handleOptionClicked = this.handleOptionClicked.bind(this);
        this.handleSelectedBadgeClicked = this.handleSelectedBadgeClicked.bind(this);
        this.handleEditAssignmentClick = this.handleEditAssignmentClick.bind(this);
        this.onMapAssignmentClick = this.onMapAssignmentClick.bind(this);
        this.getLTIMapData = this.getLTIMapData.bind(this);
    }

    componentDidUpdate(_, prevState) {


        if (this.state.data !== prevState.data) {
            this.setState({
                isMapped: true,
                selectedRadioValue: this.state.data === null ? '' : (this.state.data.for_practice?'practice' :'assignment')
            })
        }

        if (this.state.courses !== prevState.courses && this.state.data && this.state.isMapped) {
            this.handleCourseSelect(this.state.data.course_id)
        }

       if (this.state.sections !== prevState.sections && this.state.data && this.state.isMapped) {
             this.handleSectionSelect(this.state.data.section_id)
            this.setState({
                selectedRadioValue: this.state.data === null ? '' : (this.state.data.for_practice ? 'practice' :'assignment'),
            })
        }
         
        if (this.state.assignments !== prevState.assignments && this.state.data && this.state.isMapped) {
            if (this.state.data.enable_subsection) {
                this.setState({
                    selectedAssignmentIDArr: this.state.data.quiz_id
                })
            } else {
                if (this.state.data.quiz_id && this.state.data.quiz_id.length) {
                    this.handleAssignmentSelect(this.state.data.quiz_id[0])
                }
                
            }
        }

        console.debug("this.state.selectedAssignmentIDArr", this.state.selectedAssignmentIDArr, this.state.selectedRadioValue)

    }

    componentDidMount() {
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const resourceLinkTitle = params.get('resourceLinkTitle');
        const ltiQuizID = params.get('ltiQuizID');
        const ltiSectionID = params.get('ltiSectionID');
        const ltiUserID = params.get('ltiUserID');
        const carmenAssignmentID = params.get('carmenAssignmentID');
        const carmenCourseID = params.get('carmenCourseID');
        const carmenCourseName = params.get('carmenCourseName');
        const constructTakeQuizURLData = params.get('constructTakeQuizURLData');
        const token = params.get('token');

        if (token) {
            const [encodedHeader, encodedPayload, signature] = token.split('.');
            let decodedPayload;
            try {
                decodedPayload = JSON.parse(atob(encodedPayload));    
            } catch (error) {
                console.debug("error while decoding token", error, token)
            }
            
            this.appProperties.currentUserData.setUserDetails(decodedPayload,this.appProperties.loginType);

            const queryParams = new URLSearchParams(window.location.search);

            // Remove the token once it's been used
            if (queryParams.has('token')) {
                queryParams.delete('token');
                const newSearch = queryParams.toString();
                const newPath = `${window.location.pathname}?${newSearch}`;

                const encodedPath = encodeURI(newPath);

                console.debug("encodedPath", encodedPath)

                window.history.replaceState(null, '', encodedPath);
                window.location.reload();
            }
            return
        }
    

        console.debug("constructTakeQuizURLData" ,constructTakeQuizURLData)

        let hostName = window.location.hostname;
        let baseDomain = 'https://osu.instructure.com';

        if (hostName === 'osu.cpanel.dev.stemfluency.com'){
            baseDomain = 'https://canvas.ontoborn.com'
        }

        if (resourceLinkTitle) {
            this.setState({
                carmenAssignmentTitle: decodeURIComponent(resourceLinkTitle),
                ltiQuizID: ltiQuizID,
                ltiSectionID: ltiSectionID,
                ltiUserID: ltiUserID,
                carmenAssignmentID: carmenAssignmentID,
                carmenCourseID: carmenCourseID,
                carmenCourseName: carmenCourseName,
                constructTakeQuizURLData: constructTakeQuizURLData,
                carmenAssignmentURL: `${baseDomain}/courses/${carmenCourseID}/assignments/${carmenAssignmentID}`
            })
        }

        this.getCurrentSemesterLTICourses();
        
        this.getLTIMapData(ltiQuizID, ltiSectionID);

    }

    getLTIMapData(ltiQuizID, ltiSectionID) {
        
        const payload = {
            lti_quiz_id: ltiQuizID,
            lti_section_id: ltiSectionID
        };

        this.setState({
            loading: true
        })

        ApiRequestService({
            method: 'post',
            url: '/getLTI13QuizMap',
            data: payload
        }).then(res => {
            console.debug("getLTIMapData", res.data.data);

            if (res && res.data.status === 1) {
                console.debug("ERROR Message", res.data)
                if (res.data.message !== 'sql: no rows in result set') {
                    NotificationManager.error(res.data.message, 'Server Error', 5000);
                }

                return
            }

            if (res && res.data && res.data.data) {
                let mapObj = res.data.data;
                // if (mapObj.quiz_id && mapObj.quiz_id.length) {
                    this.setState({
                        data: mapObj,
                        selectedRadioValue: mapObj?.for_practice ? 'practice' : 'assignment'
                    })
                    if (mapObj && mapObj.course_id) {
                        this.handleCourseSelect(mapObj.course_id)
                    }
                    
                // }
            }

        }).finally(() => {
            this.setState({
                loading: false,
            })
        })

    }

    getCurrentSemesterLTICourses() {
        this.setState({
            loading: true
        })
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses',
        }).then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data && res.data.data.course_names) {
                if (res.data.data === null || res.data.data === undefined || res.data.data?.course_names === null || res.data.data?.course_names?.length === 0) {
                    this.setState({
                        showEmptyCourseMsg: true,
                        courseMenuItems: [],
                    })
                } else {
                    let menuItems = []
                    let allCourseNames = res.data.data.course_names
                    let ltiCourseNames = []
                    let hasAtleastOneLtiCourse = false;
                    allCourseNames.forEach(course => {
                        if (course.is_lti_enabled) {
                            hasAtleastOneLtiCourse = true; 
                            ltiCourseNames.push(course)
                            menuItems.push({
                                course_id: course.course_id,
                                label: course.course_name,
                            })
                        }
                    })
                    this.setState({
                        courses: ltiCourseNames,
                        courseMenuItems: menuItems,
                        showEmptyCourseMsg: !hasAtleastOneLtiCourse,
                    })
                }

            } else {
                this.setState({
                    showEmptyCourseMsg: true,
                    courseMenuItems: [],
                })
            }
        })
        .finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    getSectionsByCourseID(courseID) {
        if (courseID === null) {
            NotificationManager.error("Please select a course.", "Not Picked", 3000);
            return
        }
        this.setState({
            loading: true
        })
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: {
                course_id: courseID
            }
        }).then(res => {
           console.debug("res.data.data", res.data.data);
           if (res && res.data && res.data.data) {
                if (res.data.data.section_names === null || res.data.data.section_names === undefined || res.data.data.section_names?.length === 0) {
                    this.setState({
                        showEmptySectionMsg: true,
                        sectionMenuItems: [],
                    })
                } else {
                    let menuItems = []
                    res.data.data.section_names.forEach(section => {
                        menuItems.push({
                            section_id: section.section_id,
                            label: section.section_name,
                        })
                    })
                    this.setState({
                        sections: res.data.data.section_names,
                        sectionMenuItems: menuItems,
                        showEmptySectionMsg: false,
                    })
                }
           }
        })
        .finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    getAssignmentsByCourseAndSectionID(courseID, sectionID) {
        console.debug("courseID, sectionID", courseID, sectionID)
        if (courseID === null || sectionID === null) {
            NotificationManager.error("Please select a course and section", "Not Picked", 3000);
            return
        }
        this.setState({
            loading: true
        })
        ApiRequestService({
            method: 'post',
            url: '/getAllQuiz',
            data: {
                course_id: courseID,
                section_id: sectionID
            }
        }).then(res => {
           console.debug("res.data.data", res.data.data);
           if (res && res.data && res.data.data) {
                let quizes_list = res.data.data.quizes_list
                if (quizes_list === null || quizes_list === undefined || quizes_list?.length === 0) {
                    this.setState({
                        showEmptyAssignmentMsg: true,
                        assignmentMenuItems: []
                    })   
                } else {
                    let menuItems = []
                    quizes_list.forEach(quiz => {
                        menuItems.push({
                            quiz_id: quiz.quiz_id,
                            label: quiz.quiz_name,
                        })
                    })

                    let multiSelectItems = []
                    quizes_list.forEach(quiz => {
                        multiSelectItems.push({
                            id: quiz.quiz_id,
                            label: quiz.quiz_name,
                            value: this.state.data ? this.state.data.quiz_id?.includes(quiz.quiz_id) : false
                        })
                    })

                    this.setState({
                        assignments: quizes_list,
                        assignmentMenuItems: menuItems,
                        assignmentMultiSelectItems: multiSelectItems,
                        showEmptyAssignmentMsg: false,
                    })
                }
           }
        })
        .finally(() => {
            this.setState({
                loading: false
            })
        })
    }


    handleCourseSelect(courseID) {
        let index = this.state.courses && this.state.courses.length ? this.state.courses.findIndex(course => course.course_id === courseID) : -1;
        if (index < 0) return;
        let selectedCourseObj = this.state.courses[index]

        let newAssignmentMultiSelectItems = this.state.assignmentMultiSelectItems;
        newAssignmentMultiSelectItems = newAssignmentMultiSelectItems?.map(assign => {
            return {
                ...assign,
                value: false,
            }
        })

        this.setState({
            selectedCourse: selectedCourseObj,
            selectedSection: null,
            selectedRadioValue: this.state.editMode ? this.state.selectedRadioValue : '',
            sectionMenuItems: [],
            showEmptySectionMsg: false,
            selectedAssignmentIDArr: [],
            assignmentMultiSelectItems: newAssignmentMultiSelectItems,
            assignmentMenuItems: [],
            showEmptyAssignmentMsg: false,
        })

        this.getSectionsByCourseID(selectedCourseObj?.course_id)
    }

    handleSectionSelect(sectionID) {
        let index = this.state.sections && this.state.sections.length ? this.state.sections.findIndex(section => section.section_id === sectionID) : -1;
        if (index < 0) return;
        let selectedSectionObj = this.state.sections[index]
        console.debug("selectedSectionObj", selectedSectionObj)

        let newAssignmentMultiSelectItems = this.state.assignmentMultiSelectItems;
        newAssignmentMultiSelectItems = newAssignmentMultiSelectItems?.map(assign => {
            return {
                ...assign,
                value: false,
            }
        })

        this.setState({
            selectedSection: selectedSectionObj,
            selectedAssignmentIDArr: [],
            selectedRadioValue: this.state.editMode ? this.state.selectedRadioValue : '',
            assignmentMenuItems: [],
            showEmptyAssignmentMsg: false,
            assignmentMultiSelectItems: newAssignmentMultiSelectItems,
        })

        // Get assignments under the selected course and section
        this.getAssignmentsByCourseAndSectionID(this.state.selectedCourse.course_id, selectedSectionObj?.section_id)
    }

    handleRadioValueChange(val) {
        console.debug("val", val);
        if (val === 'practice') {
            let newAssignmentMultiSelectItems = this.state.assignmentMultiSelectItems;
            newAssignmentMultiSelectItems = newAssignmentMultiSelectItems?.map(assign => {
                return {
                    ...assign,
                    value: false,
                }
            })
            this.setState({
                selectedAssignmentIDArr: [],
                assignmentMultiSelectItems: newAssignmentMultiSelectItems,
            })
        }
        this.setState({
            selectedRadioValue: val,
        })
    }

    handleAssignmentSelect(quizID) {
        this.setState({
            selectedAssignmentIDArr: [quizID],
        })
    }

    handleOptionClicked(optionList) {
        // console.debug("handleOptionClicked", optionList)
        let selectedQuizArr = []
        let selectedQuizIDArr = []
        let selectedQuizes = [];
        optionList.forEach(row => {
            if(row.id !== 'enableAll' && row.id !== 'enableNone'){
                selectedQuizArr.push(row);
                if (row.value === true) {
                    selectedQuizIDArr.push(row.id)
                }
            }  
        })

        this.setState({
            assignmentMultiSelectItems: selectedQuizArr,
            selectedAssignmentIDArr: selectedQuizIDArr,
        })
    }

    handleSelectedBadgeClicked(optionList) {
        // console.debug("handleSelectedBadgeClicked", optionList)
        let selectedQuizArr = []
        let selectedQuizIDArr = []
        optionList.forEach(row => {
            if(row.id !== 'enableAll' && row.id !== 'enableNone'){
                selectedQuizArr.push(row);
                if (row.value === true) {
                    selectedQuizIDArr.push(row.id)
                }
                
            }  
        })
        this.setState({
            assignmentMultiSelectItems: selectedQuizArr,
            selectedAssignmentIDArr: selectedQuizIDArr,
        })
    }

    handleEditAssignmentClick() {
        this.setState({
            isMapped: false,
            editMode: true,
        })
    }
    
    // Map api call
    onMapAssignmentClick(forPractice) {
        console.debug("this.state.editMode", this.state.editMode)
        let payload = {
            course_id: this.state.selectedCourse.course_id,
            section_id: this.state.selectedSection.section_id,
            
            old_course_id: this.state.data?.course_id,
            old_section_id: this.state.data?.section_id,

            lti_quiz_id: this.state.ltiQuizID,
            for_practice: this.state.selectedRadioValue === 'practice' ? true : false,
            lti_section_id: this.state.ltiSectionID,
            ltiUserID: this.state.ltiUserID,
            lti_assignment_name: this.state.carmenAssignmentTitle,
            constructTakeQuizURLData: this.state.constructTakeQuizURLData,

            quiz_id: this.state.editMode && this.state.selectedRadioValue === 'practice' ? this.state.data.quiz_id : this.state.selectedAssignmentIDArr //Array of quizIDs
        }

        console.debug("payload", payload)
        
        this.setState({
            loading: true,
        })

        ApiRequestService({
            method: 'post',
            url: this.state.editMode ? '/editMapLti13Quiz' : '/mapLti13Quiz',
            data: payload
        }).then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data) {
                let mapObj = res.data.data;
                if (mapObj.quiz_id && (payload.for_practice || mapObj.quiz_id.length)) {
                    this.setState({
                        data: mapObj,
                    })
                    this.getLTIMapData(payload.lti_quiz_id, payload.lti_section_id)
                }
            }
        }).finally(() => {
            this.setState({
                loading: false,
                isMapped: true,
            })
        })

        
    }

    render() {
        return (
            <div className='map-parent'>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA==" crossorigin="anonymous" referrerpolicy="no-referrer" />
                <div className='map-container'>
                    <div className='map-heading'>
                        {this.state.isMapped ? "Assignment  Mapped ✅" : "Map Assignment"}
                    </div>

                    <div className='map-lti-card'>
                        <di className='map-lti-assignmen-card'>
                            <div className='left-container'>
                                <div className='from-to'>From</div>
                                <div className='site-title'>Canvas</div>
                            </div>
                            <a href={this.state.carmenAssignmentURL} target='_blank' className='lti-assign-card'>
                                <div>
                                    {this.state.carmenAssignmentTitle} 
                                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </div>
                            </a>
                        </di>

                        <div className='field-container'>
                            <label htmlFor="course-select">Course</label>
                            <div className="normal-list">
                                <div>{this.state.carmenCourseName}</div>
                            </div>
                        </div>
                    </div>

                    {/* Down Arrow*/}
                    <div className='down-arrow-container'>
                        <div className='down-arrow-line'></div>
                        <div className='down-arrow-head'></div>
                    </div>


                    <div className="map-sf-card">
                        <div className='sf-title' style={{
                            display: this.state.isMapped ? 'none' : 'block'
                        }}>
                            {this.state.editMode ? "Edit Mapping" : "New Mapping"}</div>
                        {/* Loader */}
                        {this.state.loading ? <div className='loader-container'><BeatLoader loading={this.state.loading} color='#bb0000' /></div> : null}

                        <div className=''>
                            <div className='from-to'>To</div>
                            <div className='site-title'>STEM Fluency</div>
                        </div>
                        <div className='all-fields-container' style={{
                            flexDirection: this.state.isMapped ? 'column-reverse' : 'column',
                        }}>
                            <div className='field-container'>
                                <label htmlFor="course-select">Course</label>
                                {this.state.isMapped ?
                                    <div className="normal-list">
                                        {/* <div>PHY 111 Autumn 2022 General Physics, Meltzer</div> */}
                                        <div>{this.state.selectedCourse?.course_name}</div>
                                    </div>
                                    : <SelectField
                                        id="course-select"
                                        className='select-field'
                                        menuItems={this.state.courseMenuItems || []}
                                        onChange={this.handleCourseSelect}
                                        value={this.state.selectedCourse?.course_id}
                                        placeholder="Select Course"
                                        itemLabel="label"
                                        itemValue="course_id"
                                    />
                                }
                                {this.state.showEmptyCourseMsg && !this.state.isMapped ?
                                    <div style={{
                                        color: 'red'
                                    }}>
                                        {/* You do not have any LTI courses assigned to you in StemFluency. Please ask your admin to give you access to a course and a section */}

                                        Cannot find any LTI courses assigned to you. Did you turn on the toggle called "LTI Course" column in the <Link to="/Courses">Courses</Link> left menu?
                                    </div>
                                    : null}
                            </div>
                            <div className='field-container' style={{
                                display: this.state.selectedCourse ? 'block' : 'none'
                            }}>
                                <label htmlFor="section-select">Section</label>
                                {this.state.isMapped ?
                                    <div className="normal-list">
                                        {/* <div>Physics 111 Section: 10:10-11:00 AM Meltzer</div> */}
                                        <div>{this.state.selectedSection?.section_name}</div>
                                    </div>
                                    : <SelectField
                                        id="section-select"
                                        className='select-field'
                                        placeholder="Select Section"
                                        itemLabel="label"
                                        onChange={this.handleSectionSelect}
                                        menuItems={this.state.sectionMenuItems || []}
                                        value={this.state.selectedSection?.section_id}
                                        itemValue="section_id"
                                    />
                                }
                                {this.state.showEmptySectionMsg && !this.state.isMapped ?
                                    <div style={{
                                        color: 'red'
                                    }}>
                                        There is no section present in this course. Please select a different course or create a section in this course.
                                    </div>
                                : null}
                            </div>

                            <div className='radio-btn-container' style={{
                                display: this.state.selectedSection && !this.state.isMapped ? 'block' : 'none'
                            }}>
                                <SelectionControlGroup
                                    disabled={this.state.isMapped || this.state.editMode}
                                    id="selection-control-group-radios"
                                    name="radio-example"
                                    type="radio"
                                    value={this.state.selectedRadioValue}
                                    onChange={this.handleRadioValueChange}
                                    controls={[{
                                        label: 'Pick an assignment',
                                        value: 'assignment',
                                    }, {
                                        label: 'Show Practice & Performance for this assignment',
                                        value: 'practice',
                                    }]}
                                />
                                <div style={{
                                    display: this.state.editMode ? 'block' : 'none'
                                }}>
                                <small>Sorry. We do not support changing from an assignment to Performance & Practice page and vice versa at the moment. Please write to esbugs@ontoborn.com for assistance with this.</small>
                                </div>
                            </div>

                            <div className='field-container assignment-container' style={{
                                // display: this.state.selectedSection && this.state.selectedRadioValue === 'assignment' ? 'block' : 'none'
                            }}>
                                <label htmlFor="section-select" style={{
                                    display: this.state.selectedSection && this.state.selectedRadioValue === 'assignment' ? 'block' : 'none'
                                }}>Assignment Name</label>
                                {this.state.isMapped ?
                                    <div className='assignments-list'>
                                        {this.state.data?.quiz_name?.map((name, index) => {
                                            let url = '';
                                            if (this.state.data.lti_quiz_Link === null ||( this.state.data.lti_quiz_Link.length && this.state.data.lti_quiz_Link[index].includes('quiz_id=-1'))) {
                                                
                                                let hostName = window.location.hostname;
                                                let baseDomain = 'https://osu.student.stemfluency.com';
                                        
                                                if (hostName === 'osu.cpanel.dev.stemfluency.com'){
                                                    baseDomain = 'https://osu.student.dev.stemfluency.com'
                                                }

                                                url = `${baseDomain}/PerfGraphsV2?tabName=performance`
                                            } else {
                                                url = this.state.data.lti_quiz_Link[index];
                                            }
                                            return (
                                                <a key={index} className='assignment-card' href={url} target='_blank' >
                                                    <div>{name}
                                                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                                    </div>
                                                    
                                                </a>
                                            )
                                        })}
                                        
                                    </div>
                                    : 
                                    <div style={{
                                        display: this.state.selectedSection && this.state.selectedRadioValue === 'assignment' ? 'block' : 'none'
                                    }}>
                                        {
                                            (this.state.selectedSection?.enable_subsection  ? 
                                                <MultiSelectReact
                                                    options={this.state.assignmentMultiSelectItems || []}
                                                    optionClicked={this.handleOptionClicked}
                                                    selectedBadgeClicked={this.handleSelectedBadgeClicked}
                                                    selectedOptionsStyles={selectedOptionsStyles}
                                                    optionsListStyles={optionsListStyles}
                                                    enableSelectAllNone={true}
                                                /> :
                                                <SelectField
                                                    id="assignment-select"
                                                    className='select-field'
                                                    placeholder="Select Assignment"
                                                    itemLabel="label"
                                                    itemValue="quiz_id" 
                                                    onChange={this.handleAssignmentSelect}
                                                    menuItems={this.state.assignmentMenuItems || []}
                                                    value={this.state.selectedAssignmentIDArr.length ? this.state.selectedAssignmentIDArr[0] : null}
                                                />)
                                        }
                                    </div>
                                }
                                {this.state.showEmptyAssignmentMsg && this.state.selectedRadioValue !== 'practice' && !this.state.isMapped ?
                                    <div style={{
                                        color: 'red'
                                    }}>
                                        There are no assignments present in the selected section. Please choose a different section or create a new assignment for this section.
                                    </div>
                                : null}
                                
                            </div>
                        </div>
                    </div>

                    <div className='action-container'>
                        {this.state.selectedCourse && this.state.selectedSection && this.state.selectedRadioValue ? 
                            (this.state.isMapped ?
                                <Button disabled={this.state.loading} raised primary onClick={this.handleEditAssignmentClick}>
                                    <div className='edit-icon-container'>
                                        {/* <i className="fa-regular fa-pen-to-square"></i> */}
                                        <i className="fa-solid fa-pen"></i>
                                    </div>
                                    Edit Assignment
                                </Button>
                                : <Button 
                                    disabled={this.state.loading || (this.state.selectedAssignmentIDArr.length === 0 && this.state.selectedRadioValue === 'assignment')} 
                                    raised primary onClick={this.onMapAssignmentClick}>Map Assignment</Button>)
                        : null}

                        <div >
                            {this.state.data && !this.state.isMapped ? <Button flat secondary className='cancel-btn' onClick={()=>{
                                this.setState({
                                    isMapped: true,
                                    data: null,
                                    editMode: false,
                                })
                                this.getLTIMapData(this.state.ltiQuizID, this.state.ltiSectionID);
                            }}>Cancel</Button> : null }
                        </div>
                    </div>
                </div>
                            
                <NotificationContainer />
            </div>
        )
    }
}
